// Accessibility helpers shared by the ui/ components.

let _seq = 0

/**
 * Tie a field to the <Label> placed just before it, when nothing else names it.
 *
 * The app writes `<Label>Пароль</Label><Input …/>` as siblings (shadcn style),
 * and ui/Label renders a <label> without `for`, so screen readers announced
 * every admin and cabinet field as just "edit text", and clicking a label
 * didn't focus its field. Looks at the previous sibling, a label heading the
 * previous sibling row (label + "Показать" button), and at the parent's
 * previous sibling (a field wrapped for an icon, or a Select's root <div>).
 * Leaves alone fields already named (a wrapping label, aria-label, -labelledby)
 * and labels already pointing somewhere.
 */
export function linkLabel(el) {
  if (!el || el.getAttribute("aria-label") || el.getAttribute("aria-labelledby")) return
  if (el.labels && el.labels.length) return
  const prev = el.previousElementSibling
  const candidates = [prev, prev?.tagName !== "LABEL" ? prev?.querySelector(":scope > label") : null,
    el.parentElement?.previousElementSibling]
  const label = candidates.find((c) => c?.tagName === "LABEL")
  if (!label || label.htmlFor || label.querySelector("input, select, textarea, button")) return
  if (!el.id) el.id = `f-${++_seq}`
  label.htmlFor = el.id
  // A <button> (ui/Select) counts as labelable too, but give it the name
  // explicitly: some screen readers ignore label[for] on buttons.
  if (el.tagName === "BUTTON") {
    if (!label.id) label.id = `${el.id}-label`
    el.setAttribute("aria-labelledby", `${label.id} ${el.id}`)
  }
}
